var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.8334C10.9602 10.8334 11.3333 10.4603 11.3333 10C11.3333 9.5398 10.9602 9.16671 10.5 9.16671C10.0397 9.16671 9.66663 9.5398 9.66663 10C9.66663 10.4603 10.0397 10.8334 10.5 10.8334Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.00004C10.9602 5.00004 11.3333 4.62694 11.3333 4.16671C11.3333 3.70647 10.9602 3.33337 10.5 3.33337C10.0397 3.33337 9.66663 3.70647 9.66663 4.16671C9.66663 4.62694 10.0397 5.00004 10.5 5.00004Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.6667C10.9602 16.6667 11.3333 16.2936 11.3333 15.8334C11.3333 15.3731 10.9602 15 10.5 15C10.0397 15 9.66663 15.3731 9.66663 15.8334C9.66663 16.2936 10.0397 16.6667 10.5 16.6667Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/verticalDots.d2379680d982bd54c9238dc7d38cb34b.svg";
export { ForwardRef as ReactComponent };